import React from 'react';
import ResourceVector from '../../../share/resource-vector.js'

export default class FleetStatistics extends React.Component {

    render() {
        let fleet = this.props.fleet;
        let used_cargo = new ResourceVector().initSparse(fleet.resources).sumUpVector();

        return (
            <div>
                <h4>Fleet Statistics</h4>
                <table className="generic-list">
                    <tbody>
                        <tr>
                            <td>Ship Count</td>
                            <td>{fleet.ship_count}</td>
                        </tr>
                        <tr>
                            <td>Attack</td>
                            <td>{fleet.stats.attack}</td>
                        </tr>
                        <tr>
                            <td>Hull Points</td>
                            <td style={{ color: fleet.stats.sustained_damage > 0 ? "red" : undefined }}>
                                {fleet.stats.structure - fleet.stats.sustained_damage} / {fleet.stats.structure} ({Math.round((fleet.stats.structure - fleet.stats.sustained_damage) / fleet.stats.structure * 1000) / 10 + "%"})
                            </td>
                        </tr>
                        <tr>
                            <td>Repair Rate</td>
                            <td>{fleet.stats.repair} hph</td>
                        </tr>
                        <tr>
                            <td>Armor</td>
                            <td>{fleet.stats.armor}</td>
                        </tr>
                        <tr>
                            <td>Shield</td>
                            <td>{fleet.stats.shield}</td>
                        </tr>
                        <tr>
                            <td>Acceleration</td>
                            <td>{fleet.stats.acceleration}</td>
                        </tr>
                        <tr>
                            <td>Cargo</td>
                            <td>{used_cargo} / {fleet.stats.cargo} ({Math.round(used_cargo / fleet.stats.cargo * 1000) / 10 + "%"})</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        );
    }
}